module.exports = __webpack_public_path__ + "static/img/8.a1f4f70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profile-pics/8.jpg
// module id = AyJ7
// module chunks = 20